import { XCircle, RotateCcw } from 'lucide-react'
import type { RejectionHistoryEntry } from '@/features/payroll/types/payroll.types'

export interface RejectionHistoryTimelineProps {
  history: RejectionHistoryEntry[]
}

export function RejectionHistoryTimeline({
  history,
}: RejectionHistoryTimelineProps): React.ReactElement | null {
  if (history.length === 0) return null

  const sorted = [...history].reverse()

  return (
    <div className="space-y-0">
      <p className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
        Rejection History ({history.length})
      </p>
      <div className="relative border-l-2 border-gray-200 pl-6 dark:border-gray-700">
        {sorted.map((entry, i) => (
          <div key={i} className="relative mb-6 last:mb-0">
            {/* Dot */}
            <div className="absolute -left-[31px] top-0.5 h-4 w-4 rounded-full border-2 border-red-400 bg-white dark:border-red-500 dark:bg-gray-800" />

            <div className="space-y-1 text-sm">
              <div className="flex items-center gap-2">
                <XCircle className="h-3.5 w-3.5 text-red-500" />
                <span className="font-medium text-gray-900 dark:text-gray-100">Rejected</span>
                <span className="text-xs text-gray-500 dark:text-gray-400">
                  {new Date(entry.rejectedAt).toLocaleString()}
                </span>
              </div>
              <p className="text-gray-700 dark:text-gray-300">{entry.reason}</p>

              {entry.resubmittedAt && (
                <div className="mt-2 flex items-center gap-2 text-xs text-green-600 dark:text-green-400">
                  <RotateCcw className="h-3 w-3" />
                  Resubmitted {new Date(entry.resubmittedAt).toLocaleString()}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

RejectionHistoryTimeline.displayName = 'RejectionHistoryTimeline'
